/**
 * Stripe's `requirements_due` field paths → what a person is actually being
 * asked for. One list for every page that names them (Money, Home), so the
 * two can never word the same requirement differently.
 *
 * Why grouped and not raw: a fresh account returns ~15 entries like
 * `identity.individual.dob.day`, one per FIELD — Stripe's shape, not a list of
 * things to go and do. The `attestations` entries are recorded by Stripe as you
 * click through its own flow; nothing to supply, so they are marked automatic.
 */
export const REQUIREMENT_GROUPS = [
  { test: /^external_account/, label: 'A bank account for payouts' },
  { test: /^identity\.individual\.(dob|date_of_birth|address)/,
    label: 'Your date of birth and address' },
  { test: /^identity\.individual\./, label: 'Your name, email and phone number' },
  { test: /^identity\.business_details/, label: 'Your business details' },
  { test: /^configuration\.merchant\.mcc/, label: 'What your apps do (a business category)' },
  { test: /^defaults\.profile\.business_url/, label: 'A website for your apps' },
  { test: /^configuration\.merchant\.statement_descriptor/,
    label: 'How your business appears on card statements' },
  // Recorded by Stripe as you accept, not supplied by you. Named so it is not mistaken
  // for a task, and not hidden, so the count still reconciles with Stripe's dashboard.
  { test: /^identity\.attestations/, label: 'Accepting Stripe’s terms',
    automatic: true },
];

/** The things still to do, in words: grouped, deduplicated, automatic ones left out, unknown paths humanised. */
export function requirementLabels(due) {
  const labels = [];
  (due || []).forEach((path) => {
    const group = REQUIREMENT_GROUPS.find((g) => g.test.test(path));
    const label = group
      ? (group.automatic ? null : group.label)
      : path.replace(/_/g, ' ').replace(/\./g, ' → ');
    if (label && !labels.includes(label)) labels.push(label);
  });
  return labels;
}
